var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFullHalf = function SvgStarFullHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    "aria-label": "star",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.39 80.57 20.24 96.42 26 62.85 1.61 39.08l33.7-4.9L50.39 3.64z",
    className: "star-full-half_svg__fill_left",
    "data-name": "fill_left"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.39 80.57 20.24 96.42 26 62.85 1.61 39.08l33.7-4.9L50.39 3.64l15.07 30.54 33.7 4.9-24.39 23.77 5.76 33.57z",
    className: "star-full-half_svg__stroke",
    "data-name": "stroke"
  })));
};
export default SvgStarFullHalf;